import React from 'react';

class LocationDetailsContainer extends React.Component {
    render() {
        return this.props.children;
    }
}

export default LocationDetailsContainer;
